
import "../../../Foundation/stylable/colors.st.css.js";
import "../../../Foundation/stylable/shadows.st.css.js";
import "../../../Foundation/stylable/spacing.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_AccordionItem";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_AccordionItem__root","header":"wds_1_76_1_AccordionItem__header","icon":"wds_1_76_1_AccordionItem__icon","titleWrapper":"wds_1_76_1_AccordionItem__titleWrapper","children":"wds_1_76_1_AccordionItem__children"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




